import "swiper/swiper-bundle.css";

import { Autoplay, EffectFade, Pagination } from "swiper/modules";

import Swiper from "swiper";
import simpleParallax from "simple-parallax-js";

var images = document.querySelectorAll(".hero img");

Array.from(document.querySelectorAll("section.hero .swiper")).map((hero) => {
	const swiper = new Swiper(hero, {
		modules: [Autoplay, Pagination, EffectFade],
		effect: "fade",
		fadeEffect: {
			crossFade: true,
		},
		autoplay: {
			delay: 7500,
		},
		loop: true,
	});
});
